import { getPageSource, track } from '@mc/track-event'
import { FooterEvents } from '../../lib/constants'
import { FooterNavigationEventProps } from '../../types/FooterNavigationEventProps'

export const trackFooterNavigationClicked = ({
  action,
  level,
  classSlug,
}: FooterNavigationEventProps) => {
  track(FooterEvents.NAV_CLIKED, {
    action,
    level,
    page_source: getPageSource(),
    ...(classSlug && { class: classSlug }),
  })
}
